"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Switch_1 = require("./Switch");
const system_1 = require("@mui/system");
const rotation = (0, system_1.keyframes) `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const animationCssRule = (0, system_1.css) `
  ${rotation} 2s linear infinite
`;
const SwitchOverrides = {
    DriftSwitch: {
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign({}, (ownerState.disabled && {
                opacity: 0.5,
            }))),
        },
        defaultProps: {
            labelProps: {
                variant: 'body2',
                fontWeight: 'bold',
                color: 'gray.700',
            },
            errorProps: {
                variant: 'body2',
                color: 'error',
            },
        },
    },
    MuiSwitch: {
        styleOverrides: {
            root: {
                height: '38px',
                width: '58px',
                padding: '12px',
            },
            colorPrimary: ({ theme }) => ({
                [`&.${Switch_1.switchClasses.checked}`]: {
                    color: theme.palette.blue[500],
                },
                [`.${Switch_1.switchClasses.disabled}`]: {
                    color: theme.palette.blue[500],
                },
            }),
            switchBase: ({ ownerState, theme }) => ({
                padding: '9px',
                ':hover': {
                    backgroundColor: `${theme.palette.gray[300]}4D`,
                },
                [`&.${Switch_1.switchClasses.checked}`]: {
                    ':hover': Object.assign({}, (ownerState.color === 'primary' && {
                        backgroundColor: `${theme.palette.blue[300]}33`,
                    })),
                    ':focus': Object.assign({}, (ownerState.color === 'primary' && {
                        backgroundColor: `${theme.palette.blue[500]}4D`,
                    })),
                    [`&.${Switch_1.switchClasses.disabled}`]: Object.assign({ color: 'white' }, (ownerState.color === 'primary' && {
                        color: theme.palette.blue[300],
                    })),
                },
                [`&.${Switch_1.switchClasses.checked} > .MuiSwitch-thumb`]: {
                    '&::before': {
                        borderColor: 'white',
                        borderBottomColor: 'transparent',
                    },
                },
                [`&.${Switch_1.switchClasses.disabled}`]: {
                    color: 'white',
                },
            }),
            thumb: ({ ownerState, theme }) => (0, system_1.css)({
                boxShadow: '0px 3px 3px -2px #00000033, 0px 3px 4px 0px #00000024, 0px 1px 8px 0px #0000001F',
                '&::before': ownerState.loading ? {
                    content: "''",
                    position: 'absolute',
                    width: '14px',
                    height: '14px',
                    top: 12,
                    left: 12,
                    borderRadius: '50%',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderColor: theme.palette.blue[500],
                    borderBottomColor: 'transparent',
                    animation: animationCssRule,
                    boxSizing: 'border-box',
                } : {}
            }),
            track: ({ ownerState, theme }) => ({
                opacity: 0.5,
                backgroundColor: theme.palette.gray[600],
                borderRadius: '100px',
                [`.${Switch_1.switchClasses.checked}.${Switch_1.switchClasses.checked} + &`]: Object.assign({ backgroundColor: theme.palette.blue[600] }, (ownerState.color === 'primary' && {
                    backgroundColor: theme.palette.blue[300],
                })),
                [`.${Switch_1.switchClasses.disabled}.${Switch_1.switchClasses.disabled} + &`]: {
                    backgroundColor: theme.palette.gray[600],
                    opacity: 0.5,
                },
                [`.${Switch_1.switchClasses.disabled}.${Switch_1.switchClasses.disabled}.${Switch_1.switchClasses.checked}.${Switch_1.switchClasses.checked} + &`]: Object.assign({}, (ownerState.color === 'primary' && {
                    backgroundColor: theme.palette.blue[300],
                })),
            }),
        },
    },
};
exports.default = SwitchOverrides;
//# sourceMappingURL=SwitchOverrides.js.map